/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Step_3_DescInputs */

const en_mk_tb_step_3_desc = /** @type {(inputs: Mk_Tb_Step_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An independent reviewer checks the current criteria and revision. Changed scope needs fresh review.`)
};

const id_mk_tb_step_3_desc = /** @type {(inputs: Mk_Tb_Step_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reviewer independen memeriksa kriteria dan revisi terkini. Lingkup yang berubah memerlukan review baru.`)
};

/**
* | output |
* | --- |
* | "An independent reviewer checks the current criteria and revision. Changed scope needs fresh review." |
*
* @param {Mk_Tb_Step_3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_step_3_desc = /** @type {((inputs?: Mk_Tb_Step_3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Step_3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_step_3_desc(inputs)
	return en_mk_tb_step_3_desc(inputs)
});